<div class="tooltip-trigger-wrapper"
     (mouseenter)="onMouseEnter()"
     (mouseleave)="onMouseLeave()"
     (keypress)="onKeyPress($event)"
     (click)="onTriggerClick($event)">
  <ng-content></ng-content>
</div>